<template>
  <div class="home">
    <!-- Banner -->
    <banner></banner>
    <!-- 最新区块，交易 -->
    <block-tx></block-tx>
  </div>
</template>
<script>
import Banner from "./Banner";
import BlockTx from "./Content";
import HomeBase from "@/mixins/Home/home.js";
export default {
  mixins: [HomeBase],
  components: {
    Banner,
    BlockTx,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.home {
}
</style>
